<template>
  <PopoverHover
    :disabled="!isActive || !user"
    :position="position"
    :has-delay="true"
  >
    <template #label>
      <slot />
    </template>
    <template v-if="user" #content>
      <div class="flex items-center">
        <UserAvatar class="mr-4" :has-popover="false" :user="user" size="12" />
        <div class="flex flex-col items-start justify-center">
          <div class="font-medium text-gray-900">{{ user.name }}</div>
          <div class="text-sm text-gray-500">
            {{ $t(`roles.${getUserRoleByValue(user.role)}.name`) }}
          </div>
        </div>
      </div>

      <Button
        v-if="selectedRollout"
        :href="
          getRolloutRelativeLink('/rollout/collaborators/profile/' + user._id)
        "
        class="mt-5 w-full text-center"
      >
        {{ $t('account.open-profile') }}
      </Button>
    </template>
  </PopoverHover>
</template>

<script lang="ts" setup>
import type { PopoverPosition } from '@/types';
import type { UserAvatarUser } from '@/components/UserAvatar.vue';
import { getUserRoleByValue } from '~/config/user-roles';
const { selectedRollout, getRolloutRelativeLink } = useRolloutRouting();

defineProps({
  isActive: {
    type: Boolean,
    default: true,
  },
  user: {
    type: Object as PropType<UserAvatarUser>,
  },
  position: {
    type: String as PropType<PopoverPosition>,
    default: 'left',
  },
});
</script>
